import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const TABLET_BP = 640;
const DESKTOP_BP = 1024;

function initCarousel(container) {
	const swiperEl = container.querySelector('.swiper');
	if (!swiperEl) {
		return;
	}

	const paginationEl = container.querySelector('.swiper-pagination');

	const d = container.dataset;
	const mobileSlidesPerView = parseFloat(d.mobileSlidesPerView) || 1;
	const mobileSlidesPerGroup = parseInt(d.mobileSlidesPerGroup) || 1;
	const tabletSlidesPerView = parseFloat(d.tabletSlidesPerView) || 2;
	const tabletSlidesPerGroup = parseInt(d.tabletSlidesPerGroup) || 1;
	const desktopSlidesPerView = parseFloat(d.desktopSlidesPerView) || 3;
	const desktopSlidesPerGroup = parseInt(d.desktopSlidesPerGroup) || 1;
	const spaceBetween = parseInt(d.spaceBetween) || 15;
	const loop = d.loop === 'true';
	const autoplay = d.autoplay === 'true';
	const autoplayDelay = parseInt(d.autoplayDelay) || 3000;
	const speed = parseInt(d.speed) || 300;

	// Create buttons once; paginationRender re-injects them after every render.
	const prevBtn = document.createElement('button');
	prevBtn.type = 'button';
	prevBtn.className = 'carousel-nav-btn carousel-nav-prev';
	prevBtn.setAttribute('aria-label', 'Edellinen');

	const nextBtn = document.createElement('button');
	nextBtn.type = 'button';
	nextBtn.className = 'carousel-nav-btn carousel-nav-next';
	nextBtn.setAttribute('aria-label', 'Seuraava');

	function updateNavState(swiper) {
		prevBtn.disabled = swiper.isBeginning && !swiper.params.loop;
		nextBtn.disabled = swiper.isEnd && !swiper.params.loop;
	}

	const modules = [Pagination];
	if (autoplay) {
		modules.push(Autoplay);
	}

	const swiper = new Swiper(swiperEl, {
		modules,
		slidesPerView: mobileSlidesPerView,
		slidesPerGroup: mobileSlidesPerGroup,
		spaceBetween,
		speed,
		loop,
		pagination: {
			el: paginationEl,
			clickable: true,
		},
		...(autoplay && {
			autoplay: {
				delay: autoplayDelay,
				pauseOnMouseEnter: true,
				disableOnInteraction: false,
			},
		}),
		breakpoints: {
			[TABLET_BP]: {
				slidesPerView: tabletSlidesPerView,
				slidesPerGroup: tabletSlidesPerGroup,
			},
			[DESKTOP_BP]: {
				slidesPerView: desktopSlidesPerView,
				slidesPerGroup: desktopSlidesPerGroup,
			},
		},
		a11y: { enabled: true },
		on: {
			// paginationRender fires on init AND after every pagination re-render
			// (e.g. breakpoint change). Re-inject buttons each time so they survive.
			paginationRender(s) {
				if (paginationEl && !paginationEl.contains(prevBtn)) {
					paginationEl.prepend(prevBtn);
				}
				if (paginationEl && !paginationEl.contains(nextBtn)) {
					paginationEl.append(nextBtn);
				}
				updateNavState(s);
			},
			slideChange(s) {
				updateNavState(s);
			},
		},
	});

	prevBtn.addEventListener('click', () => swiper.slidePrev());
	nextBtn.addEventListener('click', () => swiper.slideNext());
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.diakon-carousel').forEach(initCarousel);
});
